import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import Checkbox from 'rc-checkbox';
import { debounce } from 'lodash';

//import components
import PaginationSmall from '../pagination/PaginationSmall.js';
import LoadingIndicatorText from '../LoadingIndicator.js';

class TabFilterContent extends Component {
    defaultFiltersOnPage = 20;

    constructor(props) {
        super(props);

        this.state = {
            listFilterKey: '',
            isAllSelected: props.options.filter(option => option.selected).length === props.options.length,
            isCleanAll: props.options.filter(option => option.selected).length < 1,
            filteredOptions: props.options,
            filteredOptionsPaginate: props.options.slice(0, this.defaultFiltersOnPage),
            totalPages: Math.ceil(props.options.length/this.defaultFiltersOnPage),
            currentPage: 1,
            currentPageState: 1,
            updateFiltersList: false
        };
    };

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.options !== this.props.options) {
            this.setState({
                filteredOptions: nextProps.options.filter(option => option.label.toLowerCase().includes(this.state.listFilterKey.trim().toLowerCase() )),
            });
        }

        if (nextState.filteredOptions !== this.state.filteredOptions) {
            this.setState({
                isAllSelected: nextState.filteredOptions.filter(option => option.selected).length === nextState.filteredOptions.length && nextState.filteredOptions.length !== 0,
                isCleanAll: nextState.filteredOptions.filter(option => option.selected).length < 1,
            });
        }

        if (nextState.filteredOptions.length !== this.state.filteredOptions.length) {
            this.setState({
                totalPages: nextState.filteredOptions.length !== 0 ? Math.ceil(nextState.filteredOptions.length/this.defaultFiltersOnPage) : 1,
                currentPage: 1,
                currentPageState: 1
            });
        }

        if (nextState.updateFiltersList) {
            this.setState({
                currentPage: parseInt(nextState.currentPageState, 10),
                updateFiltersList: false
            });
        }

        if (nextState.currentPage !== this.state.currentPage || nextState.filteredOptions !== this.state.filteredOptions) {
            this.setState({
                filteredOptionsPaginate: nextState.filteredOptions.slice((nextState.currentPage - 1)*this.defaultFiltersOnPage, nextState.currentPage*this.defaultFiltersOnPage),
            });
        }
    };

    triggerLoadFilterByName = debounce(
      () => {
        this.props.loadFilterByName(this.props.name, this.state.listFilterKey.trim())
      },
      1000);

    setKey = (e) => {
      const { type, options } = this.props;

      this.setState({listFilterKey: e.target.value}, () => {
        if (type === "FACETING_API") {
           this.triggerLoadFilterByName();
        }

        if (type === "ID") {
          this.setState({
              filteredOptions: options.filter(option => option.label.toLowerCase().includes(this.state.listFilterKey.trim().toLowerCase() )),
          });
        }
      });
    };

    loadAllFilters = () => {
      this.props.loadAllFiltersByName(this.props.name)
    };

    setAllFilters = () => {
        const {setFilter, name} = this.props;
        const {filteredOptions} = this.state;

        const isNewSelected = !this.state.isAllSelected;
        this.setState({isAllSelected: isNewSelected});

        if (isNewSelected) {
            filteredOptions.forEach(function(option) {
                if (!option.selected) {
                    setFilter(name, option.id);
                }
            });
        }
    };

    cleanSelected = () => {
        const {setFilter, name} = this.props;
        const {isCleanAll, filteredOptions} = this.state;

        if (!isCleanAll) {
            filteredOptions.forEach(function(option) {
                if (option.selected) {
                    setFilter(name, option.id);
                }
            });
        }
    };

    setNextPage = () => {
        const { totalPages, currentPage } = this.state;

        if (currentPage < totalPages) {
            this.setState({currentPageState: currentPage + 1, updateFiltersList: true});
        }
    };

    setPreviousPage = () => {
        const { currentPage } = this.state;

        if (currentPage > 1) {
            this.setState({currentPageState: currentPage - 1, updateFiltersList: true});
        }
    };

    setCurrentPage = (event) => {
        const { totalPages } = this.state;
        const newVal = event.target.value;

        if ((newVal <= totalPages && newVal >= 1) || newVal === '') {
            this.setState({currentPageState: newVal !== '' ? parseInt(newVal, 10) : newVal, updateFiltersList: false});
        }
    };

    setPageByNum = (num) => {
        const { currentPage } = this.state;

        if (currentPage !== num) {
            this.setState({currentPageState: num, updateFiltersList: true});
        }
    };

    resetPageOnBlur = (event) => {
        const { currentPage, totalPages } = this.state;
        const newVal = event.target.value;

        if (newVal === '' || newVal > totalPages || newVal < 1 || parseInt(newVal, 10) === currentPage) {
            this.setState({currentPageState: currentPage, updateFiltersList: false});
        } else {
            this.setState({currentPageState: parseInt(newVal, 10), updateFiltersList: true});
        }
    };

    render() {
      const { clang, setFilter, name, isLoading, isError, type } = this.props;
      const { listFilterKey, isAllSelected, isCleanAll, totalPages, currentPage, currentPageState, filteredOptionsPaginate, filteredOptions } = this.state;

      return (
          <div className="selection-list__container">
              <div className="selection-list__navigation">
                  <div className="selection-list__navigation--top">
                      <input
                          type="text"
                          placeholder={lang[clang].results.search_for}
                          className="selection-list__search-input"
                          value={listFilterKey}
                          onChange={this.setKey}/>
                      <PaginationSmall
                          totalPages={totalPages}
                          currentPageState={currentPageState}
                          currentPage={currentPage}
                          setNextPage={this.setNextPage}
                          setPreviousPage={this.setPreviousPage}
                          setCurrentPage={this.setCurrentPage}
                          setPageByNum={this.setPageByNum}
                          noText={true}
                          resetPageOnBlur={this.resetPageOnBlur}/>
                  </div>
                  <div className="selection-list__navigation--bottom">
                      <label className="selection-list__select-all">
                          <Checkbox
                              prefixCls="checkbox--regular"
                              value={isAllSelected}
                              checked={isAllSelected}
                              onChange={() => this.setAllFilters()}
                              disabled={isAllSelected || filteredOptionsPaginate.length < 1}/>
                          {lang[clang].select_all}
                      </label>
                      <button
                          className="selection-list__clean"
                          type="button"
                          onClick={() => this.cleanSelected()}
                          disabled={isCleanAll || filteredOptionsPaginate.length < 1}>
                          {lang[clang].clean_all}
                      </button>
                  </div>
              </div>
              {filteredOptions.length >= 1 && !isLoading && !isError &&
                  <ul className="selection-list">
                      {filteredOptionsPaginate.map(option =>
                          <li className="selection-list__item" key={option.id}>
                              <label className="selection-list__item-label">
                                  <Checkbox
                                      value={option.id}
                                      onChange={() => setFilter(name, option.id)}
                                      checked={option.selected}
                                      prefixCls="checkbox--regular"/>
                                  <span dangerouslySetInnerHTML={{__html: option.label}}></span>
                                  <span className="selection-list__item-count">({option.count})</span>
                              </label>
                          </li>)}
                  </ul>}
              {type === "FACETING_API" &&
                <button
                    className="selection-list__clean"
                    type="button"
                    onClick={() => this.loadAllFilters()}
                    // disabled={isCleanAll || filteredOptionsPaginate.length < 1}
                    >
                    {lang[clang].results.get_all_filters}
                </button>}
              {isLoading &&
                <LoadingIndicatorText />}
              {isError &&
                  <p>{lang[clang].results.tab_content_error}</p>}
              {filteredOptions.length < 1 &&
                  <p>{lang[clang].results.no_filters}</p>}
          </div>
      );
    }
}

TabFilterContent.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(TabFilterContent);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/TabFilterContent.js